"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    TENTATIVE: 'tentative',
    CONFIRMED: 'confirmed',
    CANCELLED: 'cancelled',
    AWAITING_SESSION_REPORT: 'awaitingSessionReport',
    AWAITING_STUDENT_FEEDBACK: 'awaitingStudentFeedback',
    ABSENT_AWAITING_STUDENT_FEEDBACK: 'absentAwaitingStudentFeedback',
    COMPLETED: 'completed',
    ABSENT: 'absent',
    RESCHEDULED: 'rescheduled',
    DELETED: 'deleted',
    PENALTY: 'penalty',
};
//# sourceMappingURL=eventStatus.js.map